import { useCallback, useState } from "react";
import { streamsApi } from "../../lib/api/streams";
import type { Stream } from "../../lib/api/types";
import { errorMessage } from "../../lib/errors";

/** Start/stop for any number of streams; tracks which one is in flight and the last error per stream. */
export function useStreamControl(onChanged: (s: Stream) => void) {
  const [busy, setBusy] = useState<string | null>(null);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const toggle = useCallback(async (s: Pick<Stream, "id" | "desiredState">) => {
    setBusy(s.id);
    setErrors(({ [s.id]: _, ...rest }) => rest);
    try {
      onChanged(await (s.desiredState === "RUNNING" ? streamsApi.stop(s.id) : streamsApi.start(s.id)));
    } catch (e) {
      setErrors((x) => ({ ...x, [s.id]: errorMessage(e) }));
    } finally {
      setBusy(null);
    }
  }, [onChanged]);

  return { toggle, busy, errors };
}
